<template>
  <!--
        作者：kmdshop
        时间：2020-04-25
        描述：插件中心-首页推送
    -->
  <div class="api pb50">
    <!-- 搜索 -->
    <div class="api-search">
      <el-form size="small" :inline="true" class="demo-form-inline">
        <el-form-item label="接口名称">
          <el-input
            size="small"
            placeholder="请输入接口名称"
            v-model="query.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="接口标准">
          <el-select v-model="query.plugin_name">
            <el-option
              v-for="item in searchTypeOption"
              :value="item.path"
              :label="item.name"
              :key="item.api_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接口方式">
          <el-select v-model="query.mode"  clearable>
            <el-option
              v-for="item in apiModeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接口类型">
          <el-select v-model="query.api_type"  clearable>
            <el-option
              v-for="item in apiTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="域名/IP">
          <el-input
            size="small"
            placeholder="请输入域名/IP"
            v-model="query.remark"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="submitSearch"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="api-buttons">
      <div class="controll_box">
        <template v-if="query.is_delete === 1">
          <el-button
            size="small"
            type="success"
            icon="el-icon-folder"
            v-auth="'/plus/api/app/recovery'"
            @click="recoveryClick(idList)"
            >批量恢复</el-button
          >
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            v-auth="'/plus/api/app/delete'"
            @click="dellClick(idList)"
            >批量彻底删除</el-button
          >
        </template>
        <template v-else>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="addApi"
            v-auth="'/plus/api/app/index/add'"
            >添加接口</el-button
          >
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="deleteClick(idList)"
            v-auth="'/plus/api/app/index/delete'"
            >批量删除</el-button
          >
        </template>
      </div>
      <div class="show-data_box">
        <el-button
          size="small"
          :type="query.is_delete === 1 ? 'primary' : 'danger'"
          :icon="query.is_delete === 1 ? 'el-icon-tickets' : 'el-icon-delete'"
          @click="showData"
          v-auth="'/plus/api/app/dell'"
          >{{ query.is_delete === 1 ? "全部数据" : "回收站" }}</el-button
        >
      </div>
    </div>

    <my-table
      :table-list="tableList"
      :show-select="true"
      :table-option-list="tableOptionList"
      :current-page="query.curPage"
      :page-size="query.pageSize"
      :total="query.totalDataNumber"
      :loading="loading"
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
      <template slot="checkStatus" slot-scope="scope">
        <template v-if="scope.row.connectStatus != 3">
          <div class="table-colum-status">
            <el-button
              size="mini"
              type="primary"
              @click="checkClick(scope.row)"
              :disabled="scope.row.disabled"
              >检测</el-button
            >
            <i
              v-if="scope.row.connectStatus === 1"
              class="el-icon-circle-check"
              style="color: green; font-size: 20px; margin-left: 20px"
            ></i>
            <i
              v-else-if="scope.row.connectStatus === 2"
              class="el-icon-circle-close"
              style="color: red; font-size: 20px; margin-left: 20px"
            ></i>
          </div>
        </template>
        <template v-else>
          <span>不支持检测</span>
        </template>
      </template>
      <template slot="type" slot-scope="scope">
        <span>{{ apiType(scope.row.remark.plugin_name) }}</span>
      </template>
      <template slot="mode" slot-scope="scope">
        <el-tag :type="scope.row.mode === 0 ? '' : 'danger'">{{
          scope.row.mode === 0 ? "本站接口" : "外站接口"
        }}</el-tag>
      </template>
      <template slot="api_type" slot-scope="scope">
        <el-tag :type="scope.row.api_type === 0 ? '' : 'danger'">{{
          scope.row.api_type === 0 ? "开放接口" : "请求接口"
        }}</el-tag>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag :type="scope.row.status === 1 ? '' : 'danger'">{{
          scope.row.status === 1 ? "启动" : "禁用"
        }}</el-tag>
      </template>
      <template slot="action" slot-scope="scope">
        <template v-if="query.is_delete === 1">
          <el-button
            @click="recoveryClick(scope.row.api_id)"
            type="success"
            size="mini"
            v-auth="'/plus/api/app/recovery'"
          >
            恢复
          </el-button>
          <el-button
            @click="dellClick(scope.row.api_id)"
            type="danger"
            size="mini"
            v-auth="'/plus/api/app/delete'"
          >
            彻底删除
          </el-button>
        </template>

        <template v-else>
          <el-button
            @click="syncClick(scope.row)"
            type="success"
            size="mini"
            v-auth="'/plus/api/app/sync'"
            >同步</el-button
          >
          <el-button
            @click="editClick(scope.row)"
            type="primary"
            size="mini"
            v-auth="'/plus/api/app/index/edit'"
            >编辑</el-button
          >
          <el-button
            @click="deleteClick(scope.row.api_id)"
            type="danger"
            size="mini"
            v-auth="'/plus/api/app/index/delete'"
            >删除</el-button
          >
          <el-button
            v-if="scope.row.remark.plugin_name != 'hejiang_bd'"
            @click="authClick(scope.row)"
            type="primary"
            size="mini"
            v-auth="'/plus/api/app/auth'"
            >权限管理</el-button
          >
          <el-button
            v-if="scope.row.remark.plugin_name == 'baota'"
            @click="loginClick(scope.row)"
            type="primary"
            size="mini"
            v-auth="'/plus/api/app/sync'"
            >管理
          </el-button>
        </template>
      </template>
    </my-table>

    <!--添加-->
    <Edit
      v-if="open_edit"
      :open_edit="open_edit"
      :model="apiModel"
      :options="typeOptions"
      @closeDialog="closeDialog"
    ></Edit>

     <!-- 弹窗start -->
     <div class="dialogContent">
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        width="780px"
        height="800px"
      >
        <div slot="title" class="dialog-footer">
          <div style="font-size:16px">
            选择权限
          </div>
          <div class="separateline" />
        </div>
        <div style="margin-top:-10px">
          <!-- 这里是要新增一个权限接口  来获取的   -->
          <el-checkbox-group v-model="select_auth">
            <el-checkbox v-for="(item,index) in authOptions" :key="index" :label="item.api_auth_id" >{{item.remark}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="authSureClick">确定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 弹窗end -->
  </div>
</template>
<script>
import MyTable from "@/components/table/Table.vue";
import Api from "@/api/api.js";
import Edit from "./part/Edit.vue";
export default {
  components: {
    Edit,
    MyTable
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      authOptions:[],
      /*列表数据*/
      tableList: [],
      /* 显示添加模态框 */
      open_edit: false,
      /* 编辑API的Id */
      apiModel: null,
      /* 接口类型 */
      typeOptions: [],
      apiModeList:[
        {
          label:'全部',
          value:0
        },
        {
          label:'本站接口',
          value:1
        },
        {
          label:'外部接口',
          value:2
        },
      ],
      apiTypeList:[
        {
          label:'全部',
          value:0
        },
        {
          label:'开放接口',
          value:1
        },
        {
          label:'请求接口',
          value:2
        },
      ],
      /* 查询条件 */
      query: {
        pageSize: 20,
        totalDataNumber: 0,
        curPage: 1
      },
      /* 选中的Id */
      idList: [],
      tableOptionList: [
        { prop: "api_id", label: "ID", width: "80" },
        {
          label: "通讯状态",
          width: "80",
          width: "120",
          slotName: "checkStatus"
        },
        { prop: "name", label: "接口名称", width: "80" },
        { prop: "remark.type", label: "接口标准", slotName: "type" },
        { prop: "mode", label: "接口方式", slotName: "mode" },
        { prop: "api_type", label: "接口类型", slotName: "api_type" },
        { prop: "status", label: "接口状态", slotName: "status", width: "80" },
        { prop: "create_time", label: "添加时间" },
        { prop: "update_time", label: "更新时间" },
        {
          label: "操作",
          width: "320",
          other: { fixed: "right" },
          slotName: "action"
        }
      ],
      dialogVisible:false,
      select_id:"",//选择的ID
      select_auth:[]
    };
  },
  computed: {
    apiType() {
      return value => {
        const optionType =
          this.typeOptions.find(option => option.path === value) || {};
        return optionType.name;
      };
    },
    searchTypeOption() {
      return [{ path: "", name: "全部", api_id: -1 }, ...this.typeOptions];
    }
  },
  async created() {
    await this.init();
  },
  methods: {
    /* 初始化数据 */
    async init() {
      await this.getApiType();
      await this.getApiList();
      await this.getApiAuth();
    },

    /*获取数据*/
    async getApiList() {
      this.loading = true;
      try {
        const res = await Api.getData(this.query);
        this.query.totalDataNumber = res.data.list.total;
        this.query.pageSize = res.data.list.per_page;
        const tableList = res.data.list.data;
        /* 添加连接状态和禁用状态 */
        this.tableList = tableList.map(item => {
          return { ...item, disabled: false, connectStatus: -1 };
        });
      } catch (error) {}
      this.loading = false;
    },

    initQuery() {
      this.query = {
        pageSize: 15,
        totalDataNumber: 0,
        curPage: 1
      };
    },

    /* 展示回收站 */
    showData() {
      if (this.query.is_delete === 1) {
        this.initQuery();
      } else {
        this.initQuery();
        this.query.is_delete = 1;
      }
      this.getApiList();
    },

    /* 获取类型 */
    async getApiType() {
      try {
        const res = await Api.getApiType();
        this.typeOptions = res.data.list.data;
      } catch (error) {}
    },
    /* 权限类型 */
    async getApiAuth() {
      try {
        const res = await Api.getApiAuth();
        this.authOptions = res.data.list.data;
      } catch (error) {}
    },

    /* 搜索功能 */
    submitSearch() {
      this.getApiList();
    },

    /* 添加接口 */
    addApi() {
      this.open_edit = true;
    },

    /* 同步接口 */
    syncClick(row) {
      this.$confirm("此操作将数据同步到资产中, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success "
      })
        .then(async () => {
          this.loading = true;
          try {
            const res = await Api.synckApi({
              api_id: row.api_id,
              plugin_name: row.remark.plugin_name
            });
            this.$message({
              message: res.msg,
              type: res.data.code === 1 ? "success" : "error"
            });
          } catch (error) {}
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 登录宝塔 */

    async loginClick(row) {
      try {
        this.loading = true;
        const res = await Api.loginApi({
          api_id: row.api_id,
          plugin_name: row.remark.plugin_name,
          action_type: "get_login",
          user_asset_id: row.user_asset_id
        });
        if (res.data.web === 1) {
          window.open(res.data.url, "_blank");
        } else if (res.data.web === 2) {
          this.dialogVisible = true;
          this.url = res.data.url;
        }
      } catch (error) {}
      this.loading = false;
    },
    /* 打开编辑 */
    editClick(row) {
      this.open_edit = true;
      this.apiModel = row;
    },

    /* 通讯测试 */
    async checkClick(row) {
      const index = this.tableList.findIndex(item => {
        return item.api_id === row.api_id;
      });
      this.tableList[index].disabled = true;
      try {
        const result = await Api.checkApi({
          api_id: row.api_id,
          plugin_name: row.remark.plugin_name
        });
        const code = result.data.code;
        this.tableList[index].connectStatus = code;
        this.$message({
          showClose: true,
          message: result.msg,
          type: code === 1 ? "success" : "error"
        });
      } catch (error) {}
      this.tableList[index].disabled = false;
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.query.curPage = val;
      this.getApiList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.query.curPage = 1;
      this.query.pageSize = val;
      this.getApiList();
    },

    /* 关闭编辑框 */
    async closeDialog(reflush = false) {
      this.open_edit = false;
      this.apiModel = null;
      if (reflush) {
        await this.getApiList();
      }
    },

    /* 删除接口 */
    deleteClick(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将 ${id.length ? id.length : 1} 条记录移动到回收站, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await Api.deleteApi({ api_id: id });
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getApiList();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    authClick(item){
      this.dialogVisible = true;
      this.select_id = item.api_id;
      this.select_auth = [];
      if(item.auth.length>0){
        item.auth.forEach(value => {
            this.select_auth.push(parseInt(value))
        });
      }

    },
    authSureClick(){//选择权限 保存方法
      this.dialogVisible = false;
      console.log(this.select_auth)
      console.log(this.select_id)
      Api.editApiAuth({
          api_id: this.select_id,
          auth: this.select_auth
        })
        .then(result => {
           this.$message({
            showClose: true,
            message: result.msg,
            type: "success"
          });
          this.getApiList();
        })
        .catch(error => {});

      //这里是要写保存权限的方法
    },

    /* 彻底删除接口 */
    dellClick(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将 ${id.length ? id.length : 1} 彻底删除该记录, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await Api.dellApi({
              api_id: id
            });
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getApiList();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    /* 恢复删除 */
    recoveryClick(id) {
      if (typeof id === "number" || id.length > 0) {
        this.$confirm(
          `此操作将 ${id.length ? id.length : 1} 条恢复改数据, 是否继续?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success"
          }
        )
          .then(async () => {
            this.loading = true;
            const res = await Api.recoveryApi({
              api_id: id
            });
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.getApiList();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    /* 处理多选 */
    handleSelectionChange(selection) {
      this.idList = selection.map(item => item.api_id);
    }
  }
};
</script>

<style lang="scss" scoped>
.reward-list .reward-item {
  margin-bottom: 10px;
  padding: 10px 20px;
  border: 1px solid #ebeef5;
}

.reward-list .delete-reward {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
}
.table-colum-status {
  display: flex;
  align-items: center;
}
.api-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}
.api /deep/ .el-pagination {
  margin-top: 20px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/api/app/index.vue